var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4167 26.3333H3C1.61929 26.3333 0.5 25.214 0.5 23.8333V7.16658C0.5 5.78587 1.61929 4.66659 3 4.66659H28.4167C29.7974 4.66659 30.9167 5.78587 30.9167 7.16658V23.8333C30.9167 25.214 29.7974 26.3333 28.4167 26.3333ZM3 5.49992C2.07953 5.49992 1.33333 6.24611 1.33333 7.16658V23.8333C1.33333 24.7537 2.07953 25.4999 3 25.4999H28.4167C29.3371 25.4999 30.0833 24.7537 30.0833 23.8333V7.16658C30.0833 6.24611 29.3371 5.49992 28.4167 5.49992H3ZM35.5 2.58325C35.5 1.20254 34.3807 0.083252 33 0.083252H4.66667V0.916585H33C33.9205 0.916585 34.6667 1.66278 34.6667 2.58325V22.5833H35.5V2.58325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1667 23.2082V7.7915L22.4667 15.4998L12.1667 23.2082ZM13.0001 9.45817V21.5415L21.0751 15.4998L13.0001 9.45817Z",
    fill: "url(#paint0_linear_1256_9444)",
    fillOpacity: 0.93
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1256_9444",
    x1: 12.1667,
    y1: 15.4998,
    x2: 22.4667,
    y2: 15.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0079B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGallery);
export default __webpack_public_path__ + "static/media/video-gallery.5f70b2b6c15760fca0e97336272b2c2d.svg";
export { ForwardRef as ReactComponent };